<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="mini" style="width: 200px;" class="filter-item"
          :placeholder="'关键字'" v-model="listQuery.key"> </el-input>
        <el-select v-model="listQuery.showChildren" style="margin-right:10px;" size="mini" placeholder="是否显示下级代理"
          @change="handleShowChildrenChange">
          <el-option :value="true" label="显示下级代理"></el-option>
          <el-option :value="false" label="不显示下级代理"></el-option>
        </el-select>
        <el-select v-model="listQuery.enabled" style="margin-right:10px;" size="mini" placeholder="是否显示禁用条目"
          @change="handleEnabledChange">
          <el-option :value="null" label="所有"></el-option>
          <el-option :value="true" label="仅显示有效的"></el-option>
          <el-option :value="false" label="仅显示禁用的"></el-option>
        </el-select>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <permission-btn size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table style="height:calc(100% - 60px)" ref="mainTable" :select-type="'checkbox'"
          :table-fields="headerList" :data="list" :v-loading="listLoading" @row-click="rowClick"
          @selection-change="handleSelectionChange"></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange" />
      </div>
      <el-dialog v-el-drag-dialog class="dialog-mini" width="500px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible">
        <auth-form ref="dataForm" :rules="rules" :edit-model="true" :form-fields="headerList" v-model="temp"
          :col-num="1"></auth-form>
        <div slot="footer">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="mini" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog v-el-drag-dialog class="dialog-mini" width="500px" height="300px" title="导入"
        :visible.sync="importFormVisible">
        <el-form :rules="uploadRules" ref="uploadForm" :model="uploadObj" label-position="right" label-width="80px">
          <div style="padding-left: 30px;padding-bottom:20px;">
            <div class="m-15" @click="downloadTemplate">1、下载导入模版<i class="el-icon-download"></i></div>
            <div class="m-15">2、整理待导入数据到模版中</div>
            <div class="m-15">3、上传文件</div>
            <div class="m-15">
              <el-upload ref="upload" accept=".xlsx" :action="uploadUrl" :headers="headers" :limit="1"
                :before-upload="checkFileType" :on-error="handleUpload" :on-success="handleUpload"
                :show-file-list='true' :auto-upload="false">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
              </el-upload>
            </div>
          </div>

          <el-form-item size="small" :label="'代理商'" prop="selectedAgentId">
            <el-select v-model="uploadObj.selectedAgentId" placeholder="请选择">
              <el-option v-for="agent in agentOptions" :key="agent.id" :label="agent.label" :value="agent.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button size="mini" @click="importFormVisible = false">取消</el-button>
          <el-button size="mini" type="success" @click="importData"
            v-loading.fullscreen.lock="fullscreenLoading">导入</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import * as agents from '@/api/agents'
import * as iMEIs from '@/api/iMEIs'
import { getToken } from '@/utils/auth'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthForm from '../../components/Base/AuthForm.vue'
import AuthTable from '../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
export default {
  name: 'iMEI',
  components: { Sticky, permissionBtn, Pagination, AuthTable, AuthForm, },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  computed: {
    ...mapGetters(['agentId']),
    uploadUrl() {
      if (this.uploadObj) {
        return process.env.VUE_APP_BASE_API + '/imeis/Import?agentId=' + this.uploadObj.selectedAgentId;
      } else {
        return '';
      }
    }
  },
  data() {
    return {
      headers: {
        'X-Token': getToken()
      },
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      showChildren: false,
      list: null,
      agentList: [],
      agentOptions: [],
      total: 0,
      listLoading: true,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        key: undefined,
        showChildren: false,
        enabled: null
      },
      temp: {},
      uploadObj: {
        selectedAgentId: ''
      },
      importFormVisible: false,
      fullscreenLoading: false,
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      rules: {
        code: [{ required: true, message: 'IMEI号不能为空', trigger: 'blur' }],
        agentAccount: [{ required: true, message: '所属代理不能为空', trigger: 'blur' }],
      },
      uploadRules: {
        selectedAgentId: [{ required: true, message: '请选择代理商', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.uploadObj.selectedAgentId = this.agentId;
    this.getAgents();
    this.getList()
  },
  methods: {
    handleShowChildrenChange(val) {
      console.log(val)
      this.getList();
    },
    handleEnabledChange(val) {
      console.log(val)
      this.getList();
    },
    rowClick(row) {
      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onBtnClicked: function (domId, callback) {
      console.log('you click:' + domId)
      switch (domId) {
        case 'btnAdd':
          this.handleCreate()
          break
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          this.handleUpdate(this.multipleSelection[0])
          break
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error',
            })
            return
          }
          this.handleDelete(this.multipleSelection)
          break
        case 'btnExport':
          this.$refs.mainTable.exportExcel('资源文件', callback)
          break
        case 'btnImport':
          this.handleImport();
          break;
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      iMEIs.getList(this.listQuery).then((response) => {
        this.list = response.data
        this.total = response.count
        this.listLoading = false
      })
    },
    getAgents() {
      agents.getList({ page: 1, limit: 100000 }).then(res => {
        this.agentList = res.data;

        if (this.agentId != -1) {
          this.agentOptions = [...this.agentList.filter(item => item.cascadeId.indexOf(this.agentId) > -1).map(item => { return { id: item.id, value: item.account, label: item.name } })];
        } else {
          this.uploadObj.selectedAgentId = null;
          this.agentOptions = [...this.agentList.filter(item => item.id != -1).map(item => { return { value: item.account, label: item.name } })];
          console.log(this.agentList.filter(item => item.id != -1))
        }

        this.headerList = [
          new ColumnDefine('id', '', false, false, '', '', 'bigint', 'bigint', 'Id'),
          new ColumnDefine('code', 'IMEI号', true, true, 'text', '', 'string', 'varchar', 'Code'),
          new ColumnDefine('agentAccount', '所属代理', true, true, 'select', [...this.agentOptions], 'string', 'varchar', 'AgentAccount'),
          new ColumnDefine('enabled', '是否有效', true, true, 'switch', '', 'bool', 'bit', 'Enabled'),
        ];
      });
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
      })
      this.temp = Object.assign({}, obj) // copy obj
    },
    handleCreate() {
      // 弹出添加框
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      // 保存提交
      this.$refs['dataForm'].validate(() => {
        iMEIs.add(this.temp).then(() => {
          this.list.unshift(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleUpdate(row) {
      // 弹出编辑框
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      // 更新提交
      this.$refs['dataForm'].validate(() => {
        const tempData = Object.assign({}, this.temp)
        iMEIs.update(tempData).then(() => {
          for (const v of this.list) {
            if (v.id === this.temp.id) {
              const index = this.list.indexOf(v)
              this.list.splice(index, 1, this.temp)
              break
            }
          }
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleDelete(rows) {
      // 多行删除
      this.delrows(iMEIs, rows)
    },
    handleImport() {
      this.importFormVisible = true;
    },
    importData() {
      this.fullscreenLoading = true;
      this.$refs.upload.submit();
    },
    downloadTemplate() {
      let url = process.env.VUE_APP_BASE_API + '/imeis/DownloadImportTemplate';
      window.open(url);
    },
    checkFileType(file) {
      if (file.name.slice(-5).toLowerCase() != '.xlsx') {
        this.$notify({
          title: '提示',
          message: '只能导入Excel文件',
          type: 'warning',
          duration: 2000
        })
        return false;
      }
      return true;
    },
    handleUpload(res) {
      let that = this;

      if (res.code == 200) {
        this.$notify({
          title: '提示',
          message: '导入成功',
          type: 'success',
          duration: 2000
        });
        that.fullscreenLoading = false;
        that.importFormVisible = false;
        that.$refs.upload.clearFiles();

      } else {
        that.$alert(res.message, '导入失败', {
          callback: () => {
            that.fullscreenLoading = false;
            that.importFormVisible = false;
            that.$refs.upload.clearFiles();
          }
        });
      }
    }
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
